import { EMPTY_ROOT_CONTAINER_PROPS } from "@client/content/lib/consts";
import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { isUndefined } from "lodash";
import { addPost, setShowingPostId } from "../actions";
import { localStateSelector, makeForumOptionsSelector } from "../selectors";
import { type Forums } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  ...EMPTY_ROOT_CONTAINER_PROPS,
  apiInfo: null,
  id: "",

  isVisible: false,
  item: null,
  forumOptions: [],
  status: "None"
};

type Props = RootContainerProps & {
  onClose?: () => void;
  onSubmit?: (data: Forums.View.AddEditPost) => void;
};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const forumOptionsSelector = makeForumOptionsSelector();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);
    if (isUndefined(localState.showingPostId)) return INVISIBLE_PROPS;

    const item = localState.showingPostId
      ? localState.posts.find((x) => x.ticketId === localState.showingPostId)
      : null;

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),

      item: item ?? null,
      isVisible: true,
      forumOptions: forumOptionsSelector(state, props),
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onSubmit: props.onSubmit ?? ((data: Forums.View.AddEditPost) => dispatch(addPost(getEntityRef(props), data))),
  onClose: props.onClose ?? (() => dispatch(setShowingPostId({ ...getEntityRef(props), ticketId: undefined })))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
